export default "__VITE_ASSET__BDEFgBv0__"